<template>
  <div class="attendance-clock-stats-page">
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-row class="table-search" type="flex" justify="space-between" align="middle">
          <el-col :xs="24" :md="14">
            <el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
              <el-form-item label="姓名">
                <el-input
                  v-model="searchCondition.user_name"
                  placeholder="请输入姓名"
                  clearable
                  style="width: 200px;"
                  @keyup.enter.native="searchButton"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchButton">查询</el-button>
                <el-button @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :xs="24" :md="10" class="search-right">
            <el-form size="medium" :inline="true">
              <el-form-item label="月份">
                <el-select
                  v-model="monthPreset"
                  placeholder="统计月份"
                  clearable
                  style="width: 110px;"
                  @change="onMonthPresetChange"
                >
                  <el-option label="本月" value="current" />
                  <el-option label="上月" value="prev" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="searchCondition.month"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月份"
                  clearable
                  style="width: 140px;"
                  @change="onMonthPickerChange"
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-download"
                  :loading="exportLoading"
                  @click="handleExport"
                >导出</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="tableList"
          :columns="columns"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <template slot="first-column">
            <el-table-column type="selection" align="center" />
          </template>
          <el-table-column align="center">
            <template slot="header">
              <span>异常率</span>
              <el-tooltip
                placement="top"
                effect="dark"
              >
                <div slot="content" class="rate-tooltip">
                  异常率 =（迟到 + 早退 + 缺卡）÷ 任务打卡数 × 100%
                </div>
                <i class="el-icon-info header-info-icon" />
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ formatAbnormalRate(scope.row) }}
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";

function defaultMonthStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

function prevMonthStr() {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export default {
  name: "AttendanceClockStats",
  components: { PageHeaderLayout, ApeTable },
  data() {
    return {
      loadingStatus: false,
      exportLoading: false,
      contextMissionId: "",
      contextMissionName: "",
      monthPreset: "current",
      searchCondition: {
        user_name: "",
        month: defaultMonthStr(),
      },
      columns: [
        {
          title: "任务名称",
          value: "mission_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "姓名",
          value: "user_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "任务打卡数",
          value: "task_check_count",
          header_align: "center",
          align: "center",
        },
        {
          title: "实际打卡数",
          value: "actual_check_count",
          header_align: "center",
          align: "center",
        },
        {
          title: "正常打卡",
          value: "normal_count",
          header_align: "center",
          align: "center",
        },
        {
          title: "迟到",
          value: "late_count",
          header_align: "center",
          align: "center",
        },
        {
          title: "早退",
          value: "early_leave_count",
          header_align: "center",
          align: "center",
        },
        {
          title: "缺卡",
          value: "absent_count",
          header_align: "center",
          align: "center",
        },
      ],
      tableList: [],
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        offset: 0,
      },
    };
  },
  watch: {
    "$route.query": {
      handler() {
        this.applyRouteContext();
        this.init("search");
      },
      deep: true,
    },
  },
  mounted() {
    this.applyRouteContext();
    if (!this.contextMissionId && !this.contextMissionName) {
      this.$message.warning("请从打卡记录列表点击「查看」进入本页");
    }
    this.init();
  },
  methods: {
    applyRouteContext() {
      const q = this.$route.query || {};
      this.contextMissionId = q.mission_id != null ? String(q.mission_id) : "";
      this.contextMissionName = q.mission_name != null ? String(q.mission_name) : "";
      if (q.month && /^\d{4}-\d{2}$/.test(q.month)) {
        this.searchCondition.month = q.month;
        this.syncPresetFromMonth();
      }
    },
    syncPresetFromMonth() {
      const cur = defaultMonthStr();
      const prev = prevMonthStr();
      if (this.searchCondition.month === cur) this.monthPreset = "current";
      else if (this.searchCondition.month === prev) this.monthPreset = "prev";
      else this.monthPreset = "";
    },
    onMonthPresetChange(val) {
      if (val === "current") this.searchCondition.month = defaultMonthStr();
      else if (val === "prev") this.searchCondition.month = prevMonthStr();
      else if (!val) return;
    },
    onMonthPickerChange() {
      this.syncPresetFromMonth();
    },
    /** 异常率：（迟到+早退+缺卡）÷ 任务打卡数 × 100%，与说明一致 */
    formatAbnormalRate(row) {
      if (row.abnormal_rate != null && row.abnormal_rate !== "") return row.abnormal_rate;
      const denom = Number(row.task_check_count);
      if (!denom || Number.isNaN(denom)) return "—";
      const num =
        (Number(row.late_count) || 0) +
        (Number(row.early_leave_count) || 0) +
        (Number(row.absent_count) || 0);
      const pct = (num / denom) * 100;
      const rounded = Math.round(pct * 100) / 100;
      return `${rounded % 1 === 0 ? rounded : rounded.toFixed(2)}%`;
    },
    goBack() {
      this.$router.push({ path: "/attendanceClockRecord" });
    },
    searchButton() {
      this.init("search");
    },
    resetSearch() {
      this.searchCondition.user_name = "";
      this.searchCondition.month = defaultMonthStr();
      this.monthPreset = "current";
      this.init("search");
    },
    switchPaging() {
      this.init();
    },
    buildFilterParams() {
      const p = {};
      if (this.searchCondition.user_name) {
        p.user_name = this.searchCondition.user_name.trim();
      }
      if (this.searchCondition.month) {
        p.month = this.searchCondition.month;
      }
      if (this.contextMissionId) {
        p.mission_id = this.contextMissionId;
      }
      if (this.contextMissionName) {
        p.mission_name = this.contextMissionName;
      }
      return p;
    },
    async init(type) {
      if (!this.contextMissionId && !this.contextMissionName) {
        this.tableList = [];
        this.pagingData.total = 0;
        return;
      }
      if (type && this.mxResetPage) {
        this.mxResetPage();
      }
      this.loadingStatus = true;
      try {
        const pagingInfo = this.$refs.apeTable
          ? this.$refs.apeTable.getPagingInfo(type)
          : { current_page: 1, page_size: 10 };
        if (type === "search") {
          pagingInfo.current_page = 1;
        }
        const params = {
          ...this.buildFilterParams(),
          current_page: pagingInfo.current_page,
          page_size: pagingInfo.page_size,
        };
        const res = await this.$api.checkInStatsList(params);
        this.tableList = (res && res.list) || [];
        const pages = (res && res.pages) || {};
        this.pagingData.total = pages.total || 0;
        this.pagingData.offset =
          pages.offset != null ? pages.offset : (pagingInfo.current_page - 1) * pagingInfo.page_size;
      } catch (e) {
        this.tableList = [];
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "加载失败";
        this.$message.error(msg);
      } finally {
        this.loadingStatus = false;
      }
    },
    async handleExport() {
      if (!this.contextMissionId && !this.contextMissionName) {
        this.$message.warning("缺少任务信息，请从打卡记录进入");
        return;
      }
      this.exportLoading = true;
      try {
        const data = await this.$api.checkInStatsExport(this.buildFilterParams());
        const d = data && typeof data === "object" ? data : {};
        const header = d.header;
        const rows = d.rows;
        if (!header || !rows || !rows.length) {
          this.$message.warning("暂无数据可导出");
          return;
        }
        const { export_json_to_excel } = await import("@/excel/Export2Excel");
        const suffix = this.searchCondition.month || defaultMonthStr();
        const safeName = (this.contextMissionName || "任务").replace(/[/\\?%*:|"<>]/g, "_");
        export_json_to_excel({
          header,
          data: rows,
          filename: `打卡统计明细_${safeName}_${suffix}`,
          autoWidth: true,
          bookType: "xlsx",
        });
        this.$message.success("导出成功");
      } catch (e) {
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "导出失败";
        this.$message.error(msg);
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stats-toolbar {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.context-mission {
  color: #606266;
  font-size: 14px;
}

.table-search {
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.search-right {
  text-align: right;

  @media (max-width: 992px) {
    text-align: left;
    margin-top: 8px;
  }
}

.header-info-icon {
  margin-left: 4px;
  color: #409eff;
  cursor: help;
  font-size: 14px;
  vertical-align: middle;
}

.rate-tooltip {
  max-width: 280px;
  line-height: 1.5;
}
</style>
